import Vue from "vue"

export const Event = new Vue()
export const EventList = {
    buscarDatosOrden: "buscarDatosOrden"
}
